import { cn } from '../../lib/util'
import { InputProps } from './input.types'

import { inputVariants } from './input.css'

const Input = ({ className, type, ref, variant, ...props }: InputProps) => {
  return <input type={type} className={cn(inputVariants({ variant }), className)} ref={ref} {...props} />
}
Input.displayName = 'Input'

export default Input
